import Vue from 'vue';
import Router from 'vue-router';
import Landing from './pages/Landing.vue';
import Terms from './pages/Terms.vue';
import Privacy from './pages/Privacy.vue';
import Accessibility from './pages/Accessibility.vue';
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';
import Legal from './pages/Legal.vue';
import Shop from './pages/Shop.vue';
import Wedding from './pages/Wedding.vue';
import Funeral from './pages/Funeral.vue';
import Bouquets from './pages/Bouquets.vue';
import AllSoulsDay from './pages/AllSoulsDay.vue';
import Christmas from './pages/Christmas.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'index',
      components: { default: Landing, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/wedding',
      name: 'wedding',
      components: { default: Wedding, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/funeral',
      name: 'funeral',
      components: { default: Funeral, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/bouquets',
      name: 'bouquets',
      components: { default: Bouquets, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/all-souls-day',
      name: 'all-souls-day',
      components: { default: AllSoulsDay, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/christmas',
      name: 'christmas',
      components: { default: Christmas, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/shop',
      name: 'shop',
      components: { default: Shop, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/legal',
      name: 'legal',
      components: { default: Legal, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/terms',
      name: 'terms',
      components: { default: Terms, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      components: { default: Privacy, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/accessibility',
      name: 'accessibility',
      components: { default: Accessibility, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: 'black' }
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
